import axios from 'axios';
import { auth } from '../firebase'; // your firebase.ts file


export const backendAPI = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
});


export const get_all_processes = async (businessId: number) => {
  try {
    const user = auth.currentUser;
    if (!user) throw new Error("User not logged in");

    const idToken = await user.getIdToken();
    
    const response = await backendAPI.get(`processlogs/business/${businessId}`, {
      headers: {
        Authorization: `Bearer ${idToken}`,
      }
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching process logs:", error);
    throw error;
  }
};
